import { logged_in as loggedIn } from 'state';
import { getCookie } from 'bv';

const visibilityLevels = {
  loggedOut: 0,
  loggedIn: 1,
  always: 2,
};

const validVisibility = (bannerVisibilityLevel) => {
  switch (bannerVisibilityLevel) {
    case visibilityLevels.loggedOut:
      return !loggedIn();
    case visibilityLevels.loggedIn:
      return loggedIn();
    case visibilityLevels.always:
      return true;
    default:
      return false;
  }
};

export default (bannerVisibilityLevel) => !navigator.standalone
    && !getCookie('smartbanner-closed')
    && !getCookie('smartbanner-installed')
    && (!getCookie('btag') || (getCookie('btag') && loggedIn()))
    && validVisibility(bannerVisibilityLevel);
